import React, { useState, useEffect }  from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { Line } from 'react-chartjs-2';
import { makeStyles } from '@mui/styles';
import {
  Card,
  CardHeader,
  CardContent,
  Divider,
} from '@mui/material';


import { options } from './chart';


import moment from 'moment';
import palette from 'theme/palette';

const useStyles = makeStyles(() => ({
  root: {},
  chartContainer: {
    height: 400,
    position: 'relative'
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));


const LatestSales = props => {
  const { className, weekReports, currencySymbol, ...rest } = props;

  const classes = useStyles();
  const [data, setData] = useState({});
  //console.log('props.orderMonthDashboard', props.orderMonthDashboard);


const buildDataSet = (monthData) => {
  if(!monthData) {
    return;
  }
  //console.log('monthData', monthData);
  const labelList  = monthData.map(item => moment(item.date, 'DD/MM/YYYY').format('DD/MM ddd'));
  setData( {
    labels: labelList,
    datasets: [
      {
        label: 'Cash',
        backgroundColor: palette.primary.main,
        data: monthData.map(item => item.cash ? item.cash.toFixed(2) : 0),
        fill: false 
      }, 
    ]
  });
};


useEffect(() => {
  buildDataSet(props.weekReports);
  
}, [props]);


  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader
        // action={
        //   <Button
        //     size="small"
        //     variant="text"
        //   >
        //     Last 7 days <ArrowDropDownIcon />
        //   </Button>
        // }
        title="Weekly Cash Overview"
      />
      <Divider />
      <CardContent>
        <div className={classes.chartContainer}>
          {data && data.labels && data.datasets ? (
            <Line
              key={`chart-${JSON.stringify(data.labels)}`}
              data={data}
              options={options}
            />
          ) : (
            <div>Loading chart...</div>
          )}
        </div>
      </CardContent>
      <Divider />
      {/* <CardActions className={classes.actions}>
        <Button
          color="primary"
          size="small"
          variant="text"
        >
          Overview <ArrowRightIcon />
        </Button>
      </CardActions> */}
    </Card>
  );
};

LatestSales.propTypes = {
  className: PropTypes.string
};

export default LatestSales;
